import { SET_SEARCH_TERM } from 'ACTIONS';

export const setSearchTerm = (term = '', type, onSuccess) => (dispatch) => {
    dispatch(({ type: SET_SEARCH_TERM, payload: term, searchType: type }));
    if (onSuccess) {
        onSuccess();
    }
};
